import { Link } from 'react-router'

export default function LandingCTA() {
	return (
		<section className="relative overflow-hidden px-6 py-32 text-center">
			<div className="absolute inset-0 bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800" />
			<div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAzNGMwIDIuMjA5LTEuNzkxIDQtNCA0cy00LTEuNzkxLTQtNCAxLjc5MS00IDQtNCA0IDEuNzkxIDQgNHptMTAtMTBjMCAyLjIwOS0xLjc5MSA0LTQgNHMtNC0xLjc5MS00LTQgMS43OTEtNCA0LTQgNCAxLjc5MSA0IDR6IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9Ii4wNSIvPjwvZz48L3N2Zz4=')] opacity-20" />
			<div className="relative z-10 mx-auto max-w-3xl">
				<h2 className="mb-6 text-5xl font-extrabold tracking-tight text-white drop-shadow-lg md:text-6xl lg:text-7xl">
					Ready to Transform Your Workflow?
				</h2>
				<p className="mx-auto mb-12 max-w-2xl text-xl text-white/90 md:text-2xl">
					Join creators using Podly to clean up and polish every episode.
				</p>
				<Link
					to="/signup"
					className="group inline-block rounded-full bg-white px-12 py-5 text-lg font-bold text-indigo-600 shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-white/50"
				>
					Start for Free
				</Link>
			</div>
		</section>
	)
}
